import { getTariffs, addTariffs, removeTariffs } from '../../integration/tariff.api';
import { getMbbDevice, addMbbDongles } from '../../integration/mbb-devices.api';
import { removeHandset } from '../../integration/handset.api';
import structureData from '../../../util/Format.util';
import getCarts from '../../integration/cart.api';
import useLocalStorage, { getLocalStorage } from '../../hooks/useLocalStorage';
import { removeFromCartAnalytics, viewItemListAnalytics } from '../../../util/gtm';
import { createAcquisitionProspect } from '../../integration/acquisition.api';
import { getCookie, setCookie } from '../../hooks/useCookie';

const localStore = useLocalStorage();

export const getMbbTariffs = async ({ graphql }) => {
  // get Mbb tariffs
  try {
    const offerData = await getTariffs({
      graphql,
      variables: {
        serviceGroupCode: 'MBB',
        acquisitionType: getCookie('cart_type') ? getCookie('cart_type') : 'NEW_ACQUISITION',
      },
    });
    localStore.setLocalStorage('MBB_TARRIFS', JSON.stringify(offerData.tariffs));
    if (getLocalStorage('PREQUAL_RESULT')) {
      viewItemListAnalytics('Mobile_Broadband_Recommended_Tariffs', offerData.tariffs);
    }
    const result = offerData?.tariffs?.map(offer => structureData(offer, graphql));
    return result;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const addMbbTariffs = async (graphql, code, offerCode, cart) => {
  // add MBB tariffs

  let prospectReference = '';
  if (localStore.getLocalStorage('PROSPECTUUID')) {
    prospectReference = localStore.getLocalStorage('PROSPECTUUID');
  }
  let variables = {
    reference: prospectReference,
    catalogOfferCode: offerCode,
    catalogTariffPlanCode: code,
    serviceGroup: 'MBB',
    // parentOfferId: JSON.stringify(
    //   cart.offers?.find(offer => offer.baseOffer?.serviceGroup === 'MBB')?.id
    // ),
  };
  // if a MBB offer is already in cart
  if (cart?.offers.length > 0) {
    const offers = cart?.offers
      ?.filter(offer => offer.baseOffer?.serviceGroup === 'MBB')
      .map(offer => ({ id: offer.id }));
    variables = {
      ...variables,
      offers,
    };
  }

  // If prospect is not available in localstorage
  if (!localStore.hasValue('PROSPECTUUID')) {
    variables = {
      ...variables,
      prospectUuid: '',
    };
  }
  try {
    const data = await addTariffs({
      graphql,
      variables,
    });
    if (!localStore.hasValue('PROSPECTUUID')) {
      localStore.setLocalStorage('PROSPECTUUID', data.addTariff.reference);
    }
    return data.addTariff;
  } catch (error) {
    return { error };
  }
};

const getSelectedMbbOfferFromCart = async ({ graphql, localStorage }) => {
  // get the selected offer value from prospect.
  const { getCart: cartData } = await getCarts({
    graphql,
    variables: { reference: localStorage.getLocalStorage('PROSPECTUUID') || '' },
  });
  const selectedMbb = cartData?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'MBB');
  const selectedMbbAddOn = selectedMbb?.map(id => id.equipments).flat();

  return {
    cartData,
    selectedOffer: cartData?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'MBB'),
    selectedMbbAddOn,
  };
};

// on Mbb page load
export const onload = async ({ graphql, localStorage, showOnBroadband }) => {
  let result = {};
  let selectedMbbOffer = {};
  try {
    // if prospect is already present
    if (localStorage.hasValue('PROSPECTUUID')) {
      // getting selected mobile offers from cart
      const { selectedOffer, cartData, selectedMbbAddOn } = await getSelectedMbbOfferFromCart({
        graphql,
        localStorage,
      });
      // get all offers
      const offerData = await getMbbTariffs({
        graphql,
      });
      result = {
        offers: offerData,
        cartData,
      };

      // if MBB tariff available in prospect
      if (selectedOffer.length > 0) {
        // formatting select offer
        selectedMbbOffer = offerData.filter(
          offer => selectedOffer[0]?.baseOffer?.catalogTariffPlanCode === offer.code
        )[0].code;

        result = {
          ...result,
          selectedMbbOffer,
          cartData,
          selectedMbbAddOn,
        };
      }
    } else {
      if (!showOnBroadband) {
        const acq = await createAcquisitionProspect({ graphql });
        localStore.setLocalStorage('PROSPECTUUID', acq.createAcquisitionProspect);
        setCookie('ACQ', 'reference', acq?.createAcquisitionProspect);
        setCookie('ION', 'cart_Type', 'NEW_ACQUISITION');
      }
      // const offerData = await getTariffs({
      //   graphql,
      //   variables: {
      //     serviceGroupCode: 'MBB',
      //     acquisitionType: getCookie('cart_type') ? getCookie('cart_type') : 'NEW_ACQUISITION',
      //   },
      // });
      const offerData = await getMbbTariffs({
        graphql,
      });
      // localStore.setLocalStorage('MBB_TARRIFS', JSON.stringify(offerData));
      result = {
        offers: offerData,
        devices: undefined,
        selectedBroadbandOffer: false,
      };
      viewItemListAnalytics('Mobile_Broadband_Tariffs', result);
    }
  } catch (error) {
    console.error('something went wrong on load of /shop/broadband', error);
  }
  return result;
};

export const removeMbbTariffs = async (graphql, offerid) => {
  let prospectReference = '';
  if (localStore.getLocalStorage('PROSPECTUUID')) {
    prospectReference = localStore.getLocalStorage('PROSPECTUUID');
  }
  try {
    const data = await removeTariffs({
      graphql,
      variables: {
        reference: prospectReference,
        offerId: offerid,
      },
    });
    removeFromCartAnalytics(data);
    return data.removeTariff;
  } catch (error) {
    return { error };
  }
};

// to get mbbDevices
export const getMbbDevices = async (graphql, cart) => {
  const prospectReference = localStore.getLocalStorage('PROSPECTUUID');
  const cartOfferID = cart?.offers?.filter(offer => offer.baseOffer?.serviceGroup === 'MBB')[0]?.id;
  const catalogTariffCode = cart?.offers?.filter(
    offer => offer.baseOffer?.serviceGroup === 'MBB'
  )[0]?.baseOffer?.catalogTariffPlanCode;

  try {
    const data = await getMbbDevice({
      graphql,
      variables: { prospectReference, cartOfferID, catalogTariffCode },
    });
    viewItemListAnalytics('Mobile_Broadband_Equipment', data);
    return data;
  } catch (err) {
    console.error(err);
    return err;
  }
};

// to add mbbDevices
export const addMbbDevices = async (graphql, catalogCode, cart) => {
  const prospectUuid = localStore.getLocalStorage('PROSPECTUUID');
  const offerId = cart?.offers?.filter(offer => offer.baseOffer?.serviceGroup === 'MBB')[0]?.id;
  try {
    const data = await addMbbDongles({
      graphql,
      variables: { prospectUuid, offerId, catalogCode },
    });
    return data;
  } catch (err) {
    console.error(err);
  }
};

// to remove mbbDevices
export const removeMbbDevices = async (graphql, catalogCode, cart) => {
  const prospectUuid = localStore.getLocalStorage('PROSPECTUUID');
  const offerId = cart?.offers?.filter(offer => offer.baseOffer?.serviceGroup === 'MBB')[0]?.id;
  const equipmentId = cart?.offers
    .filter(offer => offer.baseOffer.serviceGroup === 'MBB')[0]
    ?.equipments.filter(eq => eq.catalogCode === catalogCode)[0]?.id;
  const variables = { offerId, prospectUuid, equipmentId };
  try {
    const data = await removeHandset({
      graphql,
      variables,
    });
    removeFromCartAnalytics(data);
    return data.removeMobileHandset;
  } catch (err) {
    console.error(err);
  }
};
